import type { Commands, Component_FULL, FormConfig } from "$lib/config";

export class FormController {
    static hidden_components: string[] = [];
    static components: Component_FULL[];
    static formDef: FormConfig;
    static callbacks: Map<string, Function> = new Map();
    static set_form_def(formDef: FormConfig) {
        this.formDef = formDef;
    }
    static do_actions(actions: Commands) {
        if (actions === undefined) {
            return;
        }
        for (let [command, comp_id] of Object.entries(actions)) {
            if (command === "show_component") {
                if (!(typeof comp_id === "string")) {
                    console.error("show_component(): Invalid component id: " + comp_id);
                    return;
                }
                this.set_visibility(comp_id, true);
            } else if (command === "hide_component") {
                if (!(typeof comp_id === "string")) {
                    console.error("show_component(): Invalid component id: " + comp_id);
                    return;
                }
                this.set_visibility(comp_id, false);
            }
        }
    }
    static on_valid_value(cb_name: string, component_id: string, cb: Function) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("on_valid_value(): Component not found: " + component_id);
            return;
        }
        //watch for comp.Comp.value to change

        this.callbacks.set(cb_name, cb);
    }
    static get_component(component_id: string): Component_FULL | null {
        for (let section of FormController.formDef.Sections) {
            for (let comp of section.Components) {
                if (comp.id === component_id) {
                    return comp;
                }
            }
        }
        return null;
    }
    static get_CenPOS_component(): Component_FULL | null {
        for (let section of FormController.formDef.Sections) {
            for (let comp of section.Components) {
                if (comp.Type === "CenPOS") {
                    return comp;
                }
            }
        }
        return null;
    }
    static set_visibility(component_id: string, visible: boolean = true) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("show_component(): Component not found: " + component_id);
            return;
        }
        if (visible) {
            if (comp.Comp !== undefined && comp.Comp.show !== undefined) {
                comp.Comp.show();
            } else {
                console.error(`show_component(): ${comp.Type} component doesn't have a show method: ` + component_id);
                return;
            }
        } else {
            if (comp.Comp !== undefined && comp.Comp.hide !== undefined) {
                comp.Comp.hide();
            } else {
                console.error(`show_component(): ${comp.Type} component doesn't have a hide method: ` + component_id);
                return;
            }
        }
        for (let i = 0; i < this.hidden_components.length; i++) {
            if (this.hidden_components[i] === component_id) {
                this.hidden_components.splice(i, 1);
                break;
            }
        }
    }
    static set_saved(component_id: string, save: boolean) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("dont_save(): Component not found: " + component_id);
            return;
        }
        if (comp.Comp !== undefined && comp.Comp.SaveData !== undefined) {
            comp.Comp.SaveData = save;
        } else {
            console.error(`dont_save(): ${comp.Type} component doesn't have a SaveData: ` + component_id);
            return;
        }
    }
    static make_readonly(component_id: string) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error(`make_readonly(): Component not found: ` + component_id);
            return;
        }
        if (comp.Comp !== undefined && comp.Comp.ReadOnly !== undefined) {
            comp.Comp.ReadOnly = true;
        } else {
            console.error(`make_readonly(): ${comp.Type} component doesn't have a readonly property: ` + component_id);
            return;
        }

    }
    static make_disabled(component_id: string) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("make_disabled(): Component not found: " + component_id);
            return;
        }
        if (comp.Comp !== undefined && comp.Comp.Disabled !== undefined) {
            comp.Comp.Disabled = true;
        } else {
            console.error("make_disabled(): Component doesn't have a disabled property: " + component_id);
            return;
        }
    }
    static make_enabled(component_id: string) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("make_enabled(): Component not found: " + component_id);
            return;
        }
        if (comp.Comp !== undefined && comp.Comp.Disabled !== undefined) {
            comp.Comp.Disabled = false;
        } else {
            console.error(`make_enabled(): ${comp.Type} component doesn't have a disabled property: ` + component_id);
            return;
        }
    }
    static set_value(component_id: string, value: any) {
        let comp = FormController.get_component(component_id);
        if (!comp) {
            console.error("set_value(): Component not found: " + component_id);
            return;
        }
        if (comp.Comp !== undefined) {
            console.log('comp.Comp', comp.Comp)
            console.log("Setting value for component: " + component_id);
            if (comp.Comp.setValue === undefined) {
                console.error(`set_value(): ${comp.Type} component doesn't have a setValue method: ` + component_id);
                return;
            }
            comp.Comp.setValue(value);
        } else {
            console.error(`set_value(): ${comp.Type} component doesn't have a setValue method: ` + component_id);
            return;
        }
    }
    static process_form_data(formData: FormData) {
        formData.set("hidden_components", JSON.stringify(this.hidden_components));
    }
}